/**
 * When the in-turn attack log resets.
 *
 * The log accumulates every roll made from the currently-selected source. It
 * used to be keyed on "selectedFromId changed", which erased it at the two
 * moments a player most wants to read it:
 *
 *   - A CONQUEST. The winning attack lands, the source has usually spent most
 *     of its armies moving in, so it stops qualifying as an attack source and
 *     the UI auto-drops the selection. That cleared the log — the three rolls
 *     that just took the territory vanished the instant they paid off.
 *   - RUNNING OUT. Same mechanism without the prize: attack until the source is
 *     down to one army and the record of how it died is wiped.
 *
 * In both cases the selection went to NULL because the board changed under the
 * player, not because they asked for a different engagement. So the rule is:
 * reset only when a source is actually being PICKED, and never on the way to
 * nothing.
 *
 * (The engagement popup's × still clears explicitly — that is a deliberate
 * "I'm done with this" and is handled at the call site, not here.)
 */
export function shouldResetAttackLog(
  previousSourceId: string | null,
  nextSourceId: string | null,
): boolean {
  if (nextSourceId === null) return false
  return nextSourceId !== previousSourceId
}
